import { PaginatedSearchRequestDto } from "./PaginatedSearchRequestDto";

export type DesignSortType = "name" | "createdat" | "printcount" | "finalized" | "user" | "status" | "id" | null;

export class PaginatedDesignSearchRequestDto extends PaginatedSearchRequestDto {
  userId: number | null = null;
  finalized: boolean | null = null;
  printed: boolean | null = null;
  createdFrom: string | null = null;
  createdTo: string | null = null;
  
  // Sort
  sortBy: DesignSortType = null;
  sortDescending: boolean | null = null;

  constructor(init?: Partial<PaginatedDesignSearchRequestDto>) {
    super();
    if (init) Object.assign(this, init);
  }
}